import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Volver",
	updateManyExternalIntegrations: {
		success: "Integraciones actualizadas con éxito",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronización pendiente",
		pendingImporting: "Importación pendiente",
	},
	ordersManager: {
		title: "Gestor de pedidos",
		description:
			"Rastrea y gestiona los pedidos que llegan de Entregue já, Comanda Online y Pedido na mesa.",
		filter: {
			placeholder: "Filtrar por",
		},
		tabs: {
			newOrders: "Nuevos Pedidos",
			inDelivery: "En Entrega",
			completed: "Concluidos",
		},
		createOrder: "Crear nuevo pedido",
		selectMenuModal: {
			title: "Elige el menú para hacer el pedido",
			searchPlaceholder: "Buscar por menú",
			productsCount: "{{value}} productos",
			cancel: "Cancelar",
			select: "Seleccionar menú",
			empty: "No se encontró ningún menú.",
		},
		createOrderScreen: {
			back: "Volver",
			searchPlaceholder: "Buscar por nombre o ítem del pedido",
			filterBy: "Filtrar por",
			allCategories: "Todas las categorías",
			all: "Todas",
			add: "Agregar",
			added: "Agregado",
			cartTitle: "Ítems agregados",
			emptyTitle: "Aún no hay nada por aquí",
			emptyDescription: "Los ítems aparecerán aquí a medida que se agreguen",
			subtotal: "Subtotal",
			discount: "Descuento",
			total: "Total",
			clear: "Limpiar ítems",
			finalize: "Finalizar pedido",
			emptyProducts: "Ningún producto encontrado.",
			productDetail: {
				title: "Detalles del producto",
				observationLabel: "Observaciones",
				observationPlaceholder: "Escribe aquí una observación del pedido",
				addProduct: "Agregar producto",
				complementsRule: "Elige hasta {{value}} opciones",
				complementsRuleRequired: "Elige de {{min}} a {{max}} opciones",
			},
			clearModal: {
				title: "Limpiar ítems",
				description:
					"¿Seguro que deseas limpiar los ítems? Al confirmar, deberás agregarlos nuevamente para finalizar.",
				cancel: "Cancelar",
				confirm: "Limpiar ítems",
			},
		},
		checkout: {
			back: "Volver",
			title: "Pago del pedido",
			customerInfo: {
				title: "Información del cliente",
				name: "Nombre",
				namePlaceholder: "Ingresa nombre y apellido del cliente",
				phone: "Teléfono",
				phonePlaceholder: "Ingresa el número de teléfono del cliente",
				cpf: "CPF",
				cpfPlaceholder: "Ingresa el número de CPF del cliente",
				sameWhatsapp: "El mismo número para WhatsApp",
			},
			delivery: {
				title: "Forma de entrega",
				pickup: "Retirar en la tienda",
				deliver: "Entregar vía mobotoy",
				addressTitle: "Información de dirección",
				cep: "Código postal",
				cepPlaceholder: "Ingresa el código postal del cliente",
				street: "Calle",
				streetPlaceholder: "Ingresa la dirección del cliente",
				number: "Número",
				numberPlaceholder: "Ingresa el número",
				complement: "Complemento",
				complementPlaceholder: "Ingresa el complemento",
			},
			payment: {
				title: "Formas de pago",
				pix: "Pago vía Pix",
			},
			summary: {
				title: "Resumen del pedido",
				deliveryFee: "Tarifa de entrega",
				total: "Total",
				finalize: "Finalizar pedido",
			},
		},
		loading: "Cargando",
		total: "Total: {{value}}",
		new: "Nuevo",
		emptyState: {
			title: "Aún no tenemos pedidos {{status}}.",
			description: "Aquí mostraremos cuando recibas nuevos pedidos.",
		},
		immersion: {
			enter: "Inmersión",
			exit: "Salir de inmersión",
		},
		sound: {
			on: "Sonido activado",
			off: "Sonido silenciado",
		},
		whatsNew: {
			intro: {
				title: "¡Tenemos novedades por aquí! 🎉",
				description:
					"Actualizamos el Gestor de pedidos. ¿Quieres ver rápido lo que cambió?",
				start: "Ver novedades",
			},
			step: "Paso {{current}} de {{total}}",
			next: "Siguiente",
			finish: "Entendido",
			skip: "Omitir",
			test: "Reproducir sonido de ejemplo",
			immersion: {
				title: "Nuevo: Modo inmersión",
				description:
					"Pon el gestor en pantalla completa, sin menús, ideal para usar en el mostrador.",
			},
			sound: {
				title: "Nuevo: Sonido de pedido nuevo",
				description:
					"Reproducimos una alerta sonora cuando llega un pedido nuevo. Usa el botón para activarlo o silenciarlo.",
			},
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
